// Styles that need to be on EVERY page should go here to avoid being double-included in webpack

import 'bootstrap/js/dist/tooltip';
import './ui/vendor/fontawesome/fontawesome.font';
import 'react-datepicker/dist/react-datepicker.css';
require('./app.component.scss');
require('./search/search-overlay/search-overlay.component.scss');
